let config = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "forwood-recovery-testing-forwoodid",
    BATCH_PROCESS_BUCKET_NAME: "forwood-recovery-testing-forwoodid-batch-user-process",
  },
  appSyncAPI: {
    REGION: "us-west-2",
    URL: "https://nzlnqzq4pvfxhnsoqsbrw3hhzi.appsync-api.us-west-2.amazonaws.com/graphql",
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://ms30ds65ka.execute-api.us-west-2.amazonaws.com/env",
    USER_TOKEN_URL: "https://g0xsh3rf90.execute-api.us-west-2.amazonaws.com/prod",
  },
  configurationService: {
    URL: "https://config.testing.recovery.forwoodsafety.com",
    WEBSOCKET: "wss://jlmo7ui728.execute-api.us-west-2.amazonaws.com/testing",
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_IMJKJE07C",
    IDENTITY_POOL_ID: "us-west-2:0560827d-38e1-45f5-abf2-93b27c9fb19f",
    USERPOOL_HOSTED_DOMAIN: "forwood-recovery-id-testing",
    USERPOOL_ADFS_CALLBACK_URL: "https://id.testing.recovery.forwoodsafety.com",
    USERPOOL_ADFS_LOGOUT_URL: "https://id.testing.recovery.forwoodsafety.com",
    AUTHENTICATED_ROLE_ARN: "arn:aws:iam::100667139682:role/testing-CA",
  },
  samlProvider: {
    NAME: "forwood",
    SUPPORTED_LIST: "forwood",
  },
  reactApp: {
    VERSION: "1.43.0",
    HOSTNAME: "id.testing.recovery.forwoodsafety.com",
    ENV_NAME: "testing",
    COOKIE_DOMAIN: ".testing.recovery.forwoodsafety.com",
    SECURE_PROTOCOL: true,
    FORWOOD_COMPANY_ID: "a542ae2b-6931-4307-8ad6-ae03c182c6ca",
    FORWOOD_HOMEPAGE_MICROFRONTEND_URL: "https://homepage.testing.recovery.forwoodsafety.com",
  },
  USERPOOL_ADFS_LAUNCH_URL(clientId) {
    return 'https://'+this.cognito.USERPOOL_HOSTED_DOMAIN+'.auth.'+this.cognito.REGION+'.amazoncognito.com/authorize?redirect_uri='+this.cognito.USERPOOL_ADFS_CALLBACK_URL+'&response_type=code&client_id='+clientId;
  },
};

export default config;
